"use client";

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type TeamRow = {
  id: number;
  name: string;
  email: string;
  role: string;
  is_active: number;
  last_activity?: string | null;
  last_login?: string | null;
};

export default function ProductAdminAttendancePage() {
  const { data = [], isLoading, isError } = useQuery({
    queryKey: ["product-admin", "attendance"],
    queryFn: async () => {
      const { data } = await api.get<{ team: TeamRow[] }>("/api/product-admin/attendance");
      return data.team;
    },
  });

  if (isLoading) return <p className="text-sm text-muted-foreground">Loading attendance…</p>;
  if (isError) return <p className="text-sm text-destructive">Could not load attendance.</p>;

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Team attendance</h1>
        <p className="text-sm text-muted-foreground">Based on login + audit activity.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Team</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left text-muted-foreground">
                  <th className="py-2 pr-3">ID</th>
                  <th className="py-2 pr-3">Name</th>
                  <th className="py-2 pr-3">Email</th>
                  <th className="py-2 pr-3">Role</th>
                  <th className="py-2 pr-3">Last login</th>
                  <th className="py-2 pr-3">Last activity</th>
                  <th className="py-2 pr-3">Active</th>
                </tr>
              </thead>
              <tbody>
                {data.map((u) => (
                  <tr key={u.id} className="border-b last:border-0">
                    <td className="py-2 pr-3">{u.id}</td>
                    <td className="py-2 pr-3 font-medium">{u.name}</td>
                    <td className="py-2 pr-3">{u.email}</td>
                    <td className="py-2 pr-3">{u.role}</td>
                    <td className="py-2 pr-3">{u.last_login ?? ""}</td>
                    <td className="py-2 pr-3">{u.last_activity ?? ""}</td>
                    <td className="py-2 pr-3">{u.is_active ? "Yes" : "No"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

